export default {
  methods: {
    dialog(value) {
      console.log("dialog", value);
    },
  },
};
